export default __webpack_public_path__ + "static/home--hero-b2ab5f4703285483da4f30980a8541b6.jpg";